import React from 'react'
import { useBrandWebsiteLinks } from 'helpers/useBrandWebsiteLinks';


const PrivacyPolicyLink = ({ props }: any) => {

    const brandWebsiteLinks = useBrandWebsiteLinks();

    return (
        <span
            className="stat-text-link"
            data-dtm="privacy statement"
            onClick={() => {
                let url = brandWebsiteLinks.getPrivacyLink();
                window.open(url, "_blank");
            }}
            style={{color: '#3A3A3A', textDecoration: 'underline', cursor: 'pointer'}}
        >
            {props}
        </span>
    )
}

export default PrivacyPolicyLink